import { z } from "zod";
// Response schemas are tolerant (z.object strips unknown keys): an API
// deployed before a client may add fields, and the client must keep working.
// Request and input schemas stay strict against mass assignment.
const CountSchema = z.number().int().nonnegative();
const TaskCountsSchema = z.object({
    business: CountSchema,
    mandatory: CountSchema,
    total: CountSchema,
});
export const LocationDashboardSchema = z.object({
    attention: z.object({
        critical: CountSchema,
        major: CountSchema,
        minor: CountSchema,
        total: CountSchema,
    }),
    comingUp: CountSchema,
    dueToday: TaskCountsSchema,
    evidence: z.object({
        completed: CountSchema,
        expected: CountSchema,
        percentage: z.number().min(0).max(100),
    }),
    excludedStaff: CountSchema,
    outOfRange: z.object({
        fail: CountSchema,
        total: CountSchema,
        warn: CountSchema,
    }),
    overdue: TaskCountsSchema,
    training: z.object({ current: CountSchema, total: CountSchema }),
    unavailable: z.array(z.string()),
    unsyncedDevices: CountSchema,
});
export const OrganisationOverviewSchema = z.object({
    locations: z.array(z.object({
        id: z.uuid(),
        name: z.string(),
        status: z.string(),
        timezone: z.string(),
        metrics: LocationDashboardSchema,
    })),
});
